import { ItiString, i18n } from '@/iti-core-vue';

//
// Clase para definir cabeceras para el DataTable de Vuetify
// mediante sintaxis 'fluent'
//

export default class ItiVHeader {
    public text!: string;
    public value!: string;
    public align: string = 'left';
    public sortable: boolean = true;
    public width: number = undefined as unknown as number;
    public class: string = ItiString.Empty;

    constructor(dtoProperty: string, i18nkey: string) {
        this.withValue(dtoProperty).withI18nKey(i18nkey);
    }

    public withValue(value: string): ItiVHeader {
        this.value = value;
        return this;
    }

    public withI18nKey(i18nKey: string): ItiVHeader {
        this.text = i18n.tc(i18nKey);
        return this;
    }

    public withAlign(align: string): ItiVHeader {
        this.align = align;
        return this;
    }

    public withSortable(sortable: boolean): ItiVHeader {
        this.sortable = sortable;
        return this;
    }

    public withWidth(width: number): ItiVHeader {
        this.width = width;
        return this;
    }

    public withClass(className: string): ItiVHeader {
        this.class = className;
        return this;
    }
}
